import { dateRangeFilterOptions } from "../../consts";

const defaultSelectedFilters = {
  selectedPeriod: dateRangeFilterOptions.THIS_WEEK,
  selectedAppType: null,
  selectedFromDate: null,
  selectedToDate: null,
  selectedDevice: null,
  locationOptions: [],
  selectedMarket: null,
  selectedLocation: null,
  selectedPlatform: null,
  selectedGroup: null,
  selectedConnectivity: null
};

export default defaultSelectedFilters;
